import { Component } from '@angular/core';

@Component({
  selector: 'app-packages',
  template: `<packages-list></packages-list>`,
})
export class PackagesComponent {}
